import { lighten, Theme } from '@mui/material/styles';

export const styleOverrides = {
    components: {
        MuiOutlinedInput: {
            styleOverrides: {
                root: ({theme}: {theme: Theme}) => ({
                    color: theme.palette.background.default,
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.text.primary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.info.main,
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.info.main,
                    },
                })
            }
        },
        MuiInputLabel: {
            styleOverrides: {
                root: ({theme}: {theme: Theme}) => ({
                    color: theme.palette.secondary.main,
                    '&.Mui-focused': {
                        color: theme.palette.info.main, 
                    },
                })
            }
        },
        MuiCssBaseline: {
            styleOverrides: (theme: Theme) =>  ({
                a: {
                    color: theme.palette.info.main
                }
            })
        },
        MuiDialogContent: {
            styleOverrides: {
                root: ({theme}: {theme: Theme}) => ({
                    backgroundColor: theme.palette.secondary.main 
                })
            }
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: ({theme}: {theme: Theme}) => ({
                    filter: theme.glow
                })
            }
        },
        MuiInputBase: {
            styleOverrides: {
                input: ({theme}: {theme: Theme}) => ({
                    color: theme.palette.text.primary
                })
            }
        },
        MuiButton: {
            styleOverrides: {
                root: ({theme}: {theme: Theme}) => ({
                    '&.Mui-disabled': {
                        color: theme.palette.secondary.main
                    },
                    '&:hover': {
                        backgroundColor: lighten(theme.palette.secondary.dark, .2)
                    }
                })
            }
        },
        MuiChip: {
            styleOverrides: {
                root: ({theme}: {theme: Theme}) => ({
                    backgroundColor: theme.palette.success.light,
                    color: theme.palette.secondary.dark
                }),
                deleteIcon: ({theme}: {theme: Theme}) => ({
                    color: theme.palette.secondary.dark
                })
            }
        },
        MuiAutocomplete: {
            styleOverrides: {
                root: ({theme}: {theme: Theme}) => ({
                    '& .MuiAutocomplete-tag': {
                        color: theme.palette.text.primary
                    },
                    '& .MuiChip-label': {
                        color: theme.palette.secondary.dark
                    },
                }),
                clearIndicator: ({theme}: {theme: Theme}) => ({
                    color: theme.palette.text.primary
                })
            }   
        },
        MuiSelect: {
            styleOverrides: {
                icon: ({theme}: {theme: Theme}) => ({
                    color: theme.palette.text.primary
                }),
            }
        },
        MuiPickersArrowSwitcher: {
            styleOverrides: {
                button: ({theme}: {theme: Theme}) => ({
                    color: theme.palette.text.primary,
                })
            },
        },
        MuiPickersCalendarHeader: {
            styleOverrides: {
                switchViewIcon: ({theme}: {theme: Theme}) => ({
                    color: theme.palette.text.primary
                }),
            },
        },
    },
}
